import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { LookupService } from '../../../shared-components/lookup/lookup.service';
import { Subscription } from 'rxjs';
import { Lookup } from '../../../shared-components/lookup/lookup.model';
import { SharedService } from '../../../shared-components/shared.service';
import { GPFilterParam } from '../gp-filter-param';

@Component({
    selector: 'app-gp-filter',
    templateUrl: './gp-filter.component.html',
    styleUrls: ['./gp-filter.component.css']
})
export class GpFilterComponent implements OnInit, OnDestroy {

    @Input() gpFilterParam: GPFilterParam;
    @Output() filterChanged = new EventEmitter<string>();
    // eslint-disable-next-line @angular-eslint/no-input-rename
    @Input('clearFilter') clearFilterEvent: EventEmitter<any>;
    @Output() closeFilterEvent = new EventEmitter();

    previousFilterData: GPFilterParam;

    dataDefTypeOfgradutionPlanType = 1587;
    subscriptions: Subscription[] = [];
    graduationPlanTypes: Lookup[] = [];


    constructor(
        private sharedService: SharedService,
        private lookupService: LookupService) { }

    ngOnInit() {
        this.previousFilterData = JSON.parse(JSON.stringify(this.gpFilterParam));

        this.subscriptions.push(
            this.lookupService.getDataDefCode(this.dataDefTypeOfgradutionPlanType).subscribe(planTypes => {
                this.graduationPlanTypes = planTypes;
                GPFilterParam.planTypes = this.graduationPlanTypes;
            })
        );

        // Subscribes to the clear filter to clear and save when it fires
        if (this.clearFilterEvent) {
            this.subscriptions.push(
                this.clearFilterEvent.subscribe(() => {
                    this.clearFilter();
                    Object.assign(this.previousFilterData, this.gpFilterParam);
                })
            );
        }
    }

    ngOnDestroy() {
        // POST: ends all subscriptions
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }

    filterChangeByModel() {
        this.filterChanged.emit('changed');
    }

    filterChange(type: string) {
        this.filterChanged.emit(type);
    }

    clearFilter() {
        this.gpFilterParam.init();
        this.filterChange('clear');
    }

    closeFilter() {
        this.closeFilterEvent.emit();
    }

}